module.exports = __webpack_public_path__ + "img/MAMO-VIOLA-DBT-Doble-Columna.bd838609.png";